/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_10352
 */

import { message } from 'ant-design-vue'
import {
  // commonConfig_activity_detail_post,
  commonConfig_activity_save_post,
  commonConfig_cookie_detail_post,
  commonConfig_cookie_save_post,
  commonConfig_footerPolicy_detail_post,
  commonConfig_footerPolicy_save_post,
  commonConfig_integratedConfig_detail_post,
  commonConfig_integratedConfig_save_post,
  commonConfig_list_post,
  commonConfig_page_enum_post,
  // commonConfig_popup_save_post,
  commonConfig_topbar_detail_post,
  commonConfig_topbar_save_post,
  commonConfig_topbar_delete_post,
  commonConfig_topbar_list_post,
  commonConfig_topbar_page_post,
  commonConfig_topbar_v2_detail_post,
  commonConfig_topbar_v2_save_post
} from 'server/modules/10352' // 查询活动入口详情
import dayjs from 'dayjs'
// import { cloneDeep } from 'lodash-es'
// export const commonConfig_activity_detail_post_ = async function(params) {
//   const { success, data, retInfo } = await commonConfig_activity_detail_post(
//     params
//   )
//   if (success) {
//     data && message.success(retInfo)
//   } else {
//     message.error(retInfo)
//   }
// }

// 保存活动入口详情
export const commonConfig_activity_save_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_activity_save_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询cookie详情
export const commonConfig_cookie_detail_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_cookie_detail_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存cookie
export const commonConfig_cookie_save_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_cookie_save_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询footer政策条详情
export const commonConfig_footerPolicy_detail_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await commonConfig_footerPolicy_detail_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存footer政策条
export const commonConfig_footerPolicy_save_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_footerPolicy_save_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询综合配置详情
export const commonConfig_integratedConfig_detail_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await commonConfig_integratedConfig_detail_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存综合配置
export const commonConfig_integratedConfig_save_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await commonConfig_integratedConfig_save_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 公共功能配置列表
export const commonConfig_list_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_list_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 展示页面枚举
export const commonConfig_page_enum_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_page_enum_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询Popup详情
// export const commonConfig_popup_detail_post_ = async function(params) {
//   const { success, data, retInfo } = await commonConfig_popup_detail_post(
//     params
//   )
//   if (success) {
//     data && message.success(retInfo)
//   } else {
//     message.error(retInfo)
//   }
// }

// 保存Popup详情
// export const commonConfig_popup_save_post_ = async function(params) {
//   const { success, retInfo } = await commonConfig_popup_save_post(params)
//   if (success) {
//     message.success(retInfo)
//   } else {
//     message.error(retInfo)
//   }
// }

// 查询Topbar详情
export const commonConfig_topbar_detail_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_topbar_detail_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存Topbar
export const commonConfig_topbar_save_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_topbar_save_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除topbar
export const commonConfig_topbar_delete_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_topbar_delete_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询所有启用topbar列表
export const commonConfig_topbar_list_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_topbar_list_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 分页查询topbar列表
export const commonConfig_topbar_page_post_ = async function(params) {
  const { success, data, retInfo } = await commonConfig_topbar_page_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 根据id查询Topbar详情
export const commonConfig_topbar_v2_detail_post_ = async function(
  params,
  state
) {
  if (!params?.id) {
    if (!state.topbarParams.topbarItemDTOList) {
      state.topbarParams.topbarItemDTOList = [
        {
          addButton: false,
          color: '#ffffff',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          textColor: '#ffffff',
          // 文案
          topbarConfigId: null // topbar 配置id
        },
        {
          addButton: true,
          color: '#ffffff',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          textColor: '#ffffff',
          // 文案
          topbarConfigId: null // topbar 配置id
        }
      ]
    }
    return
  }
  const { success, data, retInfo } = await commonConfig_topbar_v2_detail_post(
    params
  )
  if (success) {
    state.dataAll = [...data]
    state.localVisible = state.dataAll.some(item => item?.peopleType - 0 === 14)
    state.localEastVisible = state.dataAll.some(
      item => item?.peopleType - 0 === 15
    )
    state.localWestVisible = state.dataAll.some(
      item => item?.peopleType - 0 === 16
    )
    const allData = state.dataAll.find(item => item?.peopleType - 0 === 2)
    state.topbarParams = {
      ...state.resetTopbarParams,
      ...(allData || data[0] || {})
    }

    if (!state.topbarParams.topbarItemDTOList) {
      state.topbarParams.topbarItemDTOList = [
        {
          addButton: true,
          color: '#ffffff',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          // 文案
          topbarConfigId: null // topbar 配置id
        }
      ]
    }

    state.topbarParams.topbarItemDTOList.forEach(item => {
      if (item.startTime) {
        item.times = [
          dayjs(item.startTime, 'YYYY-MM-DD hh:mm:ss'),
          dayjs(item.endTime, 'YYYY-MM-DD hh:mm:ss')
        ]
      } else {
        item.times = []
      }
    })
    const buttonIdx = state.topbarParams.topbarItemDTOList.findIndex(
      item => item.addButton
    )

    if (buttonIdx === -1) {
      state.topbarParams.topbarItemDTOList.splice(
        state.topbarParams.topbarItemDTOList.length,
        0,
        {
          addButton: true,
          color: '#000000',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          // 文案
          topbarConfigId: null // topbar 配置id
        }
      )
    }
  } else {
    message.error(retInfo)
  }
  state.changeTabType()
}

// 保存Topbar
export const commonConfig_topbar_v2_save_post_ = async function(params, state) {
  const dataAll = [...state.dataAll]
  dataAll.forEach(item => {
    item.topbarItemDTOList = item.topbarItemDTOList?.filter(
      item => !item.addButton
    )
  })
  let msg = true
  dataAll.forEach(item => {
    const peopleTypeMap = {
      2: 'All人群',
      14: 'Local Sale人群',
      15: 'Local Sale美东人群',
      16: 'Local Sale美西人群'
    }
    const title = peopleTypeMap[item.peopleType] || 'All人群'
    if (item.status === undefined) {
      return message.warning(`${title}请选择是否启用`)
    }
    // if (item.topbarStyle === undefined) {
    //   return message.warning(`${title}请选择样式`)
    // }
    if (!item.backCol) {
      msg = false
      return message.warning(`${title}请选择背景颜色`)
    }
    const invalidFilterUrl =
      item.filterUrl === null ||
      item.filterUrl === undefined ||
      (typeof item.filterUrl === 'string' && item.filterUrl.trim() === '') ||
      (Array.isArray(item.filterUrl) && item.filterUrl.length === 0)
    if (invalidFilterUrl) {
      msg = false
      return message.warning(`${title}请输入不展示路由`)
    }
    item.topbarItemDTOList.forEach((sub, subIndex) => {
      sub.orderNum = subIndex + 1
      sub.langs.forEach(lang => {
        if ([undefined, '', null].includes(lang.text)) {
          msg = false
          return message.warning(`${title}${lang.langCode}下请填写文案`)
        }
      })
      if (sub.countdown - 0 !== 0) {
        if (sub.isShow === undefined) {
          msg = false
          return message.warning(`${title}请选择是否展示`)
        }
        if (!sub.startTime || !sub.endTime) {
          msg = false
          return message.warning(`${title}活动起止时间不能为空`)
        }
      }
      if (sub.countdown === 1) {
        if (!sub.startTime) {
          msg = false
          return message.warning(`${title}请选择活动开始时间`)
        }
      } else if (sub.countdown === 2) {
        if (!sub.preheatStartTime) {
          msg = false
          return message.warning(`${title}预热开始时间不能为空`)
        }
        if (sub.preheatStartTime >= sub.startTime) {
          msg = false
          return message.warning(`${title}预热开始时间不能晚于活动开始时间！`)
        }
      }
    })
  })
  if (!msg) {
    return
  }
  // for (let i = 0; i < dataAll.length; i++) {
  //   let params = dataAll[i]
  //   const cloneParams = cloneDeep(params)
  //   if (cloneParams.status === undefined) {
  //     return message.warning('请选择是否启用')
  //   }
  //   if (cloneParams.topbarStyle === undefined) {
  //     return message.warning('请选择样式')
  //   }

  //   if (!cloneParams.filterUrl) {
  //     return message.warning('请输入不展示路由')
  //   }

  //   if (!cloneParams.id) {
  //     delete cloneParams.id
  //   }

  //   cloneParams.topbarItemDTOList?.splice(
  //     cloneParams.topbarItemDTOList.length - 1,
  //     1
  //   )
  //   for (let j = 0; j < cloneParams.topbarItemDTOList.length; j++) {
  //     const element = cloneParams.topbarItemDTOList[j]
  //     console.log('element', element)
  //     if (element.countdown - 0 === 2) {
  //       if (!element.preheatStartTime) {
  //         return message.warning('预热开始时间不能为空')
  //       }
  //       if (element.preheatStartTime >= element.startTime) {
  //         return message.warning('预热开始时间不能晚于活动开始时间！')
  //       }
  //     }
  //     if (element.countdown - 0 !== 0) {
  //       if (element.isShow === undefined) {
  //         return message.error('请选择是否展示')
  //       }
  //       if (!element.startTime || !element.endTime) {
  //         return message.warning('活动起止时间不能为空')
  //       }
  //     }
  //   }
  //   const Errors = []

  //   try {
  //     cloneParams.topbarItemDTOList.forEach((item, index) => {
  //       if (!item.color) {
  //         Errors.push(index + 1)
  //       }

  //       item.langs.forEach(sub => {
  //         if ([undefined, '', null].includes(sub.text)) {
  //           const label = state.langDic.find(v => v.value === sub.langCode)
  //             ?.label
  //           Errors.push(index + 1)
  //           throw { label }
  //         }
  //       })

  //       if (item.countdown && (!item.startTime || !item.endTime)) {
  //         Errors.push(index + 1)
  //       }

  //       item.orderNum = index + 1
  //       item.topbarConfigId = cloneParams.id
  //       delete item.times
  //     })

  //     if (Errors.length) {
  //       return message.warning(
  //         `请查看Topbar${Errors.join(',')}配置是否填写完整`
  //       )
  //     }
  //   } catch (error) {
  //     console.log('error ', error)
  //     return message.error(
  //       `多语言 "${error?.label}" 下的 "Topbar${Errors.join(
  //         ','
  //       )}" 当中的 "文案" 不能为空`
  //     )
  //   }
  // }

  const { success, retInfo } = await commonConfig_topbar_v2_save_post(dataAll)

  if (success) {
    message.success(retInfo)
    // const query = state.route.query
    // state.router.push({
    //   path: 'TopBarList',
    //   query: pick(query, ['terminalId', 'brandId', 'channelId', 'siteId'])
    // })
  } else {
    message.error(retInfo)
  }
}
